import WorkflowNameWithDescription from 'automation-ui-management/components/WorkflowNameWithDescription/WorkflowNameWithDescription';
export default WorkflowNameWithDescription;